import ApiClient from "@/libs/http-client";

const AppServices = {
  endpoints(route, params) {
    const url = {
      linkLogin: "api/linking-login",
      linkOauthLogin: "api/linking-oauth-login",
      getPsychologist: `api/psychologists/paginated`,
      getProfile: `api/profile?timezone=${(params?.timezone ? encodeURIComponent(params?.timezone) : '')}`,
      createCard: "api/payment-methods",
      deleteCard: `api/payment-methods/${params?.id}`,
      getPsychologistProfile: `api/psychologists/${params?.profile_id}?timezone=${(params?.timezone ? encodeURIComponent(params?.timezone) : '')}`,
      bookTimeSlotByPatient: `api/patients/consultations/book`,
      cancelConsultationByPatient: `api/patients/consultations/${params?.id}/cancel`,
      switchLocale: `api/localization/switch`,
      sendRating: `api/patients/calls/${params?.id}/rating`,
      getPsychologistFilter: `api/general-questions`,
      deleteAccount: "api/auth/delete-account",
      favorites: "api/patients/favorites",
      favoriteIds: "api/patients/favorites/ids",
      addFavorite: `api/patients/favorites/${params?.id}`,
      removeFavorite: `api/patients/favorites/${params?.id}`,
    };

    return url[route];
  },

  get(url, data) {
    return ApiClient.get(this.endpoints(url, data));
  },
  post(url, params = {}, data, config = {}) {
    return ApiClient.post(this.endpoints(url, params), data, config);
  },
  patch(url, params = {}, data, config = {}) {
    return ApiClient.patch(this.endpoints(url, params), data, config);
  },
  delete(url, params = {}, data, config = {}) {
    return ApiClient.delete(this.endpoints(url, params), data, config);
  },
};

export default AppServices;
